function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
  cx: "50%",
  cy: "50%",
  fx: "50%",
  fy: "50%",
  r: "75.6965002%",
  gradientTransform: "translate(0.500000,0.500000),scale(0.880041,1.000000),translate(-0.500000,-0.500000)",
  id: "radialGradient-1"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#3D94D2",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#ADD6B2",
  offset: "100%"
})));
var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Offline-icon",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_544",
  transform: "translate(6.000000, 6.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M31.2912,35.6841 C36.1512,52.0848 41.0679,68.6331 45.891,84.9249 C43.9758,86.6673 43.4502,88.9164 43.1253,91.2384 L88.8912,84.7116 C89.0622,85.2894 89.2329,85.8669 89.4033,86.4441 L41.9598,93.2103 L25.1829,36.54 L31.2912,35.6841 Z",
  id: "Path_774",
  fill: "#313133"
}), /*#__PURE__*/React.createElement("path", {
  d: "M37.881,20.5362 L75.2211,15.2109 C81.7401,35.9487 88.2582,56.6865 94.7754,77.4243 C78.9606,79.6797 63.1461,81.9351 47.3319,84.1905 L32.8788,35.46 L38.7558,34.6329 L40.5864,41.6961 L51.7401,40.1265 L48.9501,29.3652 L40.4784,30.5577 L37.881,20.5353 L37.881,20.5362 Z M26.9559,15.0696 L15.1209,16.7346 L18.6993,30.5406 L33.0093,28.5273 L29.8539,16.3566 L37.1187,15.3342 L34.6833,5.94 L24.9435,7.3116 L26.9559,15.0723 L26.9559,15.0696 Z M18.0225,0.873 L19.8549,7.9425 L12.5271,8.9739 L10.6938,1.9035 L18.0225,0.873 L18.0225,0.873 Z M10.2375,13.0734 L0.1008,14.499 L2.6352,24.2793 L12.7719,22.8528 L10.2375,13.0734 L10.2375,13.0734 Z M60.5304,41.2434 L52.6455,42.3522 L54.6174,49.9599 L62.5014,48.8493 L60.5304,41.2434 Z",
  id: "Path_775",
  fill: "url(#radialGradient-1)"
})));
function SvgOfflineIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "106px",
    height: "105px",
    viewBox: "0 0 106 105",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Offline-icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOfflineIcon);
export default __webpack_public_path__ + "static/media/Offline-icon.30f88e5f0551344382ab61a848ca2be7.svg";
export { ForwardRef as ReactComponent };